var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Traverses an RHF error object with lots of depth until it finds
 * ref objects and stops, then pulls that out as a path to the component
 * that tripped the error.
 */
export var flattenErrorsToPaths = function (errors) {
    var outputPaths = [];
    var flatten = function (obj, prefix, suffix) {
        if (prefix === void 0) { prefix = ''; }
        if (suffix === void 0) { suffix = ''; }
        Object.entries(obj).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            var path = "".concat(prefix).concat(key).concat(suffix);
            if (!value.ref) {
                if (Array.isArray(value) || typeof value === 'object') {
                    flatten(value, "".concat(path, "."));
                }
            }
            else {
                outputPaths.push(path);
            }
        });
    };
    flatten(errors);
    return outputPaths;
};
/**
 * Give this to OnKeyDown handlers and it'll allow you to tab to the next
 * ui element, but it'll swallow all other keyboard commands.
 */
export var disableAllButTab = function (e) {
    if (e.key !== 'Tab' && e.cancelable) {
        e.preventDefault();
    }
    return false;
};
/**
 * Validates the provided form using form.trigger() and then digs through
 * the error paths to setFocus on the first one with errors.
 */
export var validateAndFocusInvalidFields = function (
/** The form we're validating */
form, 
/**
 * An object with exception functions where we don't simply focus the field
 * The first example was diagnosis search where a hidden field had the validation
 * but we wanted to focus the search input.
 *
 * key: the name of the field with validations on it.
 * value: a function that does what you need to do to focus
 * the right thing.
 */
exceptionPaths) { return __awaiter(void 0, void 0, void 0, function () {
    var isValid, paths;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, form.trigger()];
            case 1:
                isValid = _a.sent();
                if (!isValid && form.formState.errors) {
                    paths = flattenErrorsToPaths(form.formState.errors);
                    if (paths.length > 0) {
                        if (exceptionPaths && exceptionPaths[paths[0]]) {
                            exceptionPaths[paths[0]]();
                        }
                        else {
                            form.setFocus(paths[0]);
                        }
                    }
                }
                return [2 /*return*/, isValid];
        }
    });
}); };
